export default __webpack_public_path__ + "static/media/icon_error.21b8b320.svg";